import React, { useState, useEffect, Fragment } from 'react'
import { Card, Button, Col, Alert } from 'react-bootstrap'
import MyForm2 from './MyForm2'
import MyForm2Details from './MyForm2Details'

function MyCard(props) {
    // console.log('MyCard - props:',props)
    
    // useEffect(() => {
        
    // }, [])
    
    return (
        <>
            <Col
                sm={Array.isArray(props?.bs_grid) && props?.bs_grid[0]}
                md={Array.isArray(props?.bs_grid) && props?.bs_grid[1]}
                lg={Array.isArray(props?.bs_grid) && props?.bs_grid[2]}
                xl={Array.isArray(props?.bs_grid) && props?.bs_grid[3]}
                xxl={Array.isArray(props?.bs_grid) && props?.bs_grid[4]}
            >
                <Card
                    className={props?.className}
                >
                    {
                        props?.title &&
                        <Card.Body className="pb-0">
                            <Card.Title className="pb-0" style={{borderBottom:'0px solid #eee'}}>
                                {/* <div className="float-start">{props?.title}</div> */}
                                {props?.title}
                                <div style={{clear:'both'}}/>
                            </Card.Title>
                            <hr className="m-0" />
                        </Card.Body>
                    }

                    <Card.Body>
                        {
                            props?.type === 'show-details'
                            ?
                                <>
                                    <MyForm2Details
                                        fields_dic_prefix={props?.fields_dic_prefix}
                                        fields={props?.fields}
                                        control={props?.control} 
                                        getValues={props?.getValues} 
                                        reset={props?.reset}
                                        errors={props?.errors}

                                        extraComponents={props?.extraComponents}
                                    />
                                </>
                            :
                                <>
                                {
                                    ( props?.showErrors && props?.serverErrors !== null && props?.serverErrors !== undefined ) && 
                                    <Col md="6">
                                        <Alert variant="danger">
                                            <ul>
                                            {
                                                Object.keys(props?.serverErrors).map((property) => {
                                                    return props?.serverErrors[property]?.map((value, index) => {
                                                        if(property === 'message')
                                                            return (<h6 key={index} className="text-danger">{value}</h6>)
                                                        else
                                                            return (<li key={index}>{value}</li>)
                                                    })
                                                })
                                            }
                                            </ul>
                                        </Alert>
                                    </Col>
                                }
                                
                                <MyForm2
                                    fields_dic_prefix={props?.fields_dic_prefix}
                                    fields={props?.fields}
                                    control={props?.control} 
                                    getValues={props?.getValues} 
                                    reset={props?.reset}
                                    errors={props?.errors}

                                    extraFunctions={props?.extraFunctions}
                                    extraComponents={props?.extraComponents}
                                >
                                    {props?.children}
                                </MyForm2>

                                {
                                    props?.showButtons &&
                                    <div className="form-group mt-2 mb-0">
                                        <Button type="submit" className="btn btn-primary btn-block float-end px-5"
                                            disabled={props?.doingSubmit}
                                        >
                                            {
                                                props?.doingSubmit ? 'در حال ثبت اطلاعات ...' : props?.buttonTitle || 'ثبت'
                                            }
                                        </Button>
                                    </div>
                                }
                                </>
                        }
                    </Card.Body>
                </Card>
            </Col>
        </>
    )
}


export default MyCard;